export function initializeExternalLinks() {
  document.querySelectorAll('a[href]').forEach((link) => {
    const href = link.getAttribute('href');
    if (!href) return;

    const isPdf = href.toLowerCase().endsWith('.pdf');
    const isExternal = /^https?:/i.test(href) && new URL(href).hostname !== window.location.hostname;

    if (isPdf || isExternal) {
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
    }
  });
}
